// import components
import { Box, styled } from '@mui/material';
import { StyledFormControlLabel } from 'components/admin-portal/Tables/Settings/AdminFunctions/filter/FilterComponent.styles';
import { GridCompact3 } from 'components/shared/Grid/Grid.components';

export const CustomStyledFormControlLabel = styled(StyledFormControlLabel)(
  () => ({
    '&&, .MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label': {
      marginLeft: 0,
      lineHeight: 'unset'
    }
  })
);

export const StyledFormContainerBox = styled(Box)(() => ({
  '& > section:first-of-type': { paddingTop: 0 },
  '& > section > div:last-of-type': { marginTop: 0, marginLeft: 0 }
}));

export const StyledGridCompact3 = styled(GridCompact3)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));
